import { rem, Bold } from '@core-web/typography';
import { Box, styled } from '@mui/material';

export const InfoModalWrapper = styled(Box)(({ theme: { palette, breakpoints } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: `${rem(64)} ${rem(24)} ${rem(32)}`,
  backgroundColor: palette.colors.white,
  boxShadow: palette.boxShadow.modalShadow,
  borderRadius: rem(12),
  width: rem(600),
  gap: rem(32),
  position: 'relative',
  [breakpoints.down(700)]: {
    width: '80%',
  },
}));

export const ModalHeader = styled(Box)(() => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  borderBottom: '1px',
  borderColor: '#D3D3D3',
  padding: '16px 24px',
  backgroundColor: '#E9EFF6',
  width: '100%',
}));

export const HeaderTitle = styled(Box)(() => ({
  color: '#1C222B',
  fontSize: rem(16),
  fontWeight: Bold._500,
}));

export const ModalBody = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: rem(16),
}));

interface IInfoModalIconWrapper {
  iconColor?: string;
}

export const InfoModalIconWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'iconColor',
})<IInfoModalIconWrapper>(({ theme: { palette }, iconColor }) => ({
  display: 'flex',
  color: palette.colors.blue_700,
  fontSize: rem(64),
  ' svg': {
    fontSize: 'inherit',
    ...(iconColor && { fill: iconColor }),
  },
  '&.danger': {
    color: palette.error.main,
  },
}));

interface IInfoModalProps {
  customStyle?: boolean;
}

export const InfoModalTitle = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'customStyle',
})<IInfoModalProps>(({ theme: { palette }, customStyle }) => ({
  display: 'flex',
  fontSize: rem(customStyle ? 14 : 16),
  fontWeight: Bold._500,
  lineHeight: rem(24),
  letterSpacing: '-0.2px',
  color: palette.colors.grey_500,
}));

export const ModalFooter = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  gap: rem(8),
  width: '100%',
}));

export const CloseBtnWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: rem(14),
  right: rem(4),
}));
